export default "__VITE_ASSET__4f69401b__"